import React from 'react'
import FooterText from '../ui/atoms/FooterText'
import { Brand } from './typings'

const ebaycb: Brand = {
  clientInfo: {
    displayName: 'EBAYCB',
    accountNumberLengths: [16],
    footerDisplay: 'ebay.com',
    footerLink: 'https://www.ebay.com/',
    applicationUrl: 'https://pages.ebay.com/creditcard/',
    dsecApigeeClientId: {
      development: 'xlhAVv13oMhherQ8MgAtzVsHsfqfAqrp',
      production: 'X78XdbCp96A8F33MJIdjYRvTvdS1PF2D'
    },
    persistApigeeClientId: { development: '', production: '' },
    setpayApigeeClientId: {
      development: '',
      production: ''
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your EBAYCB credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito EBAYCB en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    languages: ['en'],
    vanityUrl: 'ebay.com',
    hostname: 'ebaymastercard.syf.com',
    linkingRedirect: '',
    ivaKey: '767e3c14-a145-45c1-a67c-88ac3a01a489',
    hasMss: true,
    hasCpl: false,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: false,
    footerContent: {
      en: (
        <>
          <FooterText>
            Your eBay Credit Card is issued by Synchrony Bank. The Synchrony
            Bank Privacy Policy governs the use of the eBay Credit Card. The use
            of this site is governed by the use of the Synchrony Bank Internet
            Privacy Policy, which is different from the privacy policy of eBay.
          </FooterText>
          <FooterText>
            *Purchases subject to credit approval. Account must remain open, be
            in good standing and not become delinquent to earn Reward Points and
            be issued a statement credit. Accrued Reward Points will expire in
            24 months if a sufficient amount has not been earned to be issued a
            statement credit or there are no purchases for 12 consecutive
            months. See the Rewards Program Terms for details.
          </FooterText>
          <FooterText>
            **The Primary Cardholder will be liable for all purchases made on
            the Account, including those made by an Authorized User.
          </FooterText>
          <FooterText>
            The eBay Mastercard is issued by Synchrony Bank pursuant to a
            license by Mastercard international incorporated. Mastercard is a
            registered trademark, and the circles design is a trademark of
            Mastercard international incorporated.
          </FooterText>
        </>
      ),
      es: ''
    },
    phoneNumbers: {
      loan: '',
      dualcard: '1-866-419-4095',
      fraud: '1-844-435-0237',
      customerService: '1-844-435-0295',
      plcc: ''
    },
    iOSAppId: '',
    androidApp: {
      id: '',
      author: '',
      title: '',
      image: ''
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/dualcard/@ebaycb/en/html/ess020832.html',
      es: ''
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/dualcard/@ebaycb/en/html/ess020829.html',
      es: ''
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/dualcard/@ebaycb/en/html/ess020830.html',
      es: ''
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/dualcard/@ebaycb/en/html/ess020831.html',
      es: ''
    },
    voice: {
      cardName: '',
      google: {
        termsAndConditionsLink: ''
      },
      alexa: {
        termsAndConditionsLink: ''
      }
    }
  },
  palette: {
    field: {
      icon: '#333333',
      focus: '#34657F',
      label: ''
    },
    progressStepBar: {
      fill: '#333333',
      label: '#333333'
    },
    progressBar: {
      complete: '',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    button: {
      primary: {
        text: '#FFFFFF',
        hover: '#015c75'
      },
      secondary: {
        hover: '#acd9e5'
      },
      background: '#01718f'
    },
    checkbox: {
      background: '#3664f3',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '#76E3E0',
    bodyBackground: '#FFFFFF',
    iconBackground: '#dadada',
    headerBackground: '#FFFFFF',
    modalBackground: '#FFFFFF',
    formBackground: '#f2f2f2',
    headerDivider: '#FFFFFF',
    footerDivider: '#142435',
    contrastingText: '#FFFFFF',
    bodyText: '#333333',
    languageSelector: '#4c68ae',
    focus: '',
    link: '#4c68ae',
    footer: {
      background: '#ececec',
      text: '#333333',
      link: '#333333'
    }
  },
  images: {
    logo: {
      en: '/assets/ebaycb/logo.png',
      es: '/assets/ebaycb/logo.png'
    },
    hero: '',
    heroBgDesktop: '',
    heroBgMobile: '',
    mainPromo: {
      en: '/assets/ebaycb/promo.png',
      es: '/assets/ebaycb/promo.png'
    },
    voiceCplLogo: ''
  }
}

export default ebaycb
